<template>
  <div>
    <header-sales></header-sales>
    <!--pc view-->
    <div v-if="!mobileView">
      <div id= "subheader"> </div> 
      <div id= "main-container" style="top: 50vh; height: 90vh;"> 
        <div class="fv lc" style="width: 700px; height: 10vh">
          <span id="label">Devoluciones</span>
        </div> 
        <div id= "container" style="height: 82vh">
          <div id="list-container">
            <item-pedido id="list-prod" v-for="item in items" :item='item' @eliminarItem="btnEliminarItem"  ></item-pedido>
          </div>
          <div class="fv rc" style="width: 100%; margin-top: 10px">
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Subtotal: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{subtotal | formatMoney}} </div>
              </div>
              <!-- <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Descuentos: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{descuentos | formatMoney}} </div>
              </div> -->
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Impuestos: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{impuestos | formatMoney}} </div>
              </div>
              <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 14px; color:#5D6770"> Total: </div>
                  <div class="fh rc" style="width: 150px; font-size: 14px; color:#5D6770"> ${{subtotal + impuestos | formatMoney}} </div>
              </div>
          </div>
          <div id="btnContainer" style="margin-top: 5px">
            <input id="btnEliminar" @click="btnEliminar" type="submit" value="ELIMINAR">
            <!-- <input id="btnGuardar" @click="btnGuardar" type="submit" value="GUARDAR"> -->
            <input id="btnAgregar" @click="btnAgregar" type="submit" value="AGREGAR">
            <input id="btnEnviar" @click="btnEnviar" type="submit" value="ENVIAR">
          </div> 
        </div> 
      </div> 
    </div> 


    <!--mobile view-->
    <div v-if="mobileView">
      <div class="fv ct" style="width: 100vw; height:100vh;">
          <div class="fh cc" style="width: 100%; height:4%; background:#44C7F4; color:white; font: size 12px;">Devoluciones</div>
          <div class="fh cc" style="width: 100%; height:5%; background:#eeeeee;">
            <div class="fh cc" style="width: 33%; height:100%; font-size: 14px; color: #5C666F">Subtotal: ${{subtotal | formatMoney}}</div>
            <div class="fh cc" style="width: 33%; height:100%; font-size: 14px; color: #5C666F">Impuestos: ${{impuestos | formatMoney}}</div>
            <div class="fh cc" style="width: 33%; height:5%;font-size: 18px; font-weight: 500; color: #5C666F" >Total: ${{subtotal  | formatMoney}}</div>
          </div>
          <div id="list-container" style="height: 55%">
            <item-pedido id="list-prod" v-for="item in items" :item='item' @eliminarItem="btnEliminarItem"> </item-pedido>
          </div>
          <div class="fh cc" style="margin-top: 20px">
            <div class="btnMobile" style="background: white;color:#ff0000; border:none" @click="btnEliminar">ELIMINAR</div>
            <!-- <div class="btnMobile" style="background: white;color: #4969B2; border-style: solid; border-color: #4969B2;" @click="btnGuardar">GUARDAR</div> -->
            <div class="btnMobile" @click="btnAgregar">AGREGAR</div>
            <div class="btnMobile" @click="btnEnviar">ENVIAR</div>
          </div> 
      </div>
    </div>

 <!-- ....................................... POPUP ........................................ -->
   <!--pc view-->
   <div v-if="!mobileView">
     <transition name="fadePro">
      <div v-show='showPopup' :showPopup='showPopup'>
        <div id='back-popup'>
        </div>
        <div id='popup-envio-pedido'>
          <div id='popup-btnClose-container'>
            <img id='btnClose' @click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
          </div>
          <p id='popup-titulo' style="margin-bottom: 20px">Enviar Devolución</p>
          <div class="labels-forms" v-show="showEmail">Email para envíar la devolución en PDF</div>
          <input style="text-align: left;  padding-left: 10px; margin-left:30px;margin-bottom: 20px; width:336px;height:30px;font-size: 14px; font-weight: 100;  border-radius:5px;border-style:solid;" type="email" v-model='email' v-show="showEmail">
          <div class="labels-forms">Observaciones</div>
          <textarea id='obs' v-model="observaciones"> </textarea>
          <div id="btnContainerPopup">
            <button  @click="btnCerrarPopup" id="btnclose">CANCELAR</button>
            <button  @click="btnEnviarPopup" id="btnsend">ENVIAR</button>
          </div>
        </div>
      </div>
     </transition>
   </div>

   <!--mobile view-->
   <div v-if="mobileView">
     <transition name="fadePro">
      <div class="fv lt"   v-show='showPopup' :showPopup='showPopup'>
        <div id='back-popup'>
        </div>
        <div id='popup-envio-pedido' style="width: 90vw">
          <div class="fh rb" style="width: 100%; height: 30px;">
            <img id='btnClose' @click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px; margin-right: 15px">
          </div>
          <div class="fh cc" style="height: 60px; font-size: 18px; color: #5C666F;">Enviar Devolución</div>   
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;" v-show="showEmail">Email para envíar la devolución en PDF</div>
          <input style="text-align: left;  padding-left: 10px; margin-left: 5%;margin-bottom: 10px; width:88%; height:30px;font-size: 14px;border-radius:5px;border-style:solid; color: black" type="email" v-model='email' v-show="showEmail">
          <div class="fh lc" style="margin-left: 5%; height: 10%; font-size: 12px; color: #5C666F;">Observaciones</div>   
          <textarea style="resize: none; width: 85%; margin-left: 5%; padding: 10px; border-radius: 5px; height:90px; border-style: solid; border-width: 1px;border-color: #dddddd; font-family:'Rubik', sans-serif;"  v-model="observaciones"> </textarea>
          <div id="btnContainerPopup">
            <button  @click="btnCerrarPopup" id="btnclose">CANCELAR</button>
            <button  @click="btnEnviarPopup" id="btnsend">ENVIAR</button>
          </div>
        </div>
      </div>
     </transition>
   </div>

  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemDevolucion from '@components/views/devoluciones/ItemDevolucion.vue';
  import Vue from 'vue'
  import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
  import * as lang from "vuejs-datepicker/src/locale";


  export default {
    name: 'devolucion',
    components:{
     'header-sales': HeaderSales,
     'item-pedido': ItemDevolucion,
      Datepicker
    },

    data() {
       return {
         showPopup:false,
         productos:[],
         pedido:null,
         pedidos: [],
         observaciones:'',
         sucursal: "",
         condicionVenta:"",  
         numPedidoEdit:false,
         idItemEliminar:-1,
         calendario:"",
         errorMsg:"", 
         disabledDates: 
         {
           to: null,
           days: [],
           dates:[]
         },
         mobileView:false,
         email:"",
         totalImpuesto: 0,  

       }
    },



    computed: {

      showEmail () 
      {
         return this.$store.state.user.usuario.PermiteEnvioPdf 
      },

      numPedido()
      {
        if ((this.$store.state.pedido.pedidosHome != null) && (this.$store.state.pedido.pedidosHome.length > 0))
        {
          return this.$store.state.pedido.pedidosHome[0].Id
        }
        else
        {
          return 0
        }
      },

    //   items () {
    //     return this.$store.state.pedido.carrito    
    //   }, 

      items() {
        var carrito = this.$store.state.pedido.carrito
        var impuesto = 0
        this.totalImpuesto = 0 
        carrito.forEach((c)=> { 
            var totalDesc = 0
            impuesto = c.precio * c.cantidad * (c.porcentajeImpuesto/100)
            this.totalImpuesto = this.totalImpuesto + impuesto 
        });
        return carrito
      },  

      subtotal () {
        var st= 0.0; 
        this.$store.state.pedido.carrito.forEach(function(element) {
          st = st + element.precio * element.cantidad;
        });     
        return st + this.totalImpuesto;
      },

      impuestos() {
        return this.totalImpuesto
      }


    },


  methods: {

    onResize() {
        if (window.innerWidth > 600) 
        {
          this.mobileView=false;
        }
        else 
        {
          this.mobileView=true;
        }
      },

    btnEdit() {
      if (this.numPedidoEdit)
      {
        this.numPedidoEdit = false
      }
      else
      {
        this.numPedidoEdit = true
      }
    },

    validar() {
      var rex = new RegExp(/^\d+$/);
      var rex2 = new RegExp(/^[0-9]+([.,][0-9]+)?$/);
      var ok = true;

      this.$store.state.pedido.carrito.forEach((e)=> {


        if (e.permiteDecimales) { 
            if (!rex2.test(e.cantidad)) 
            {
                ok = false;
                this.errorMsg = "Todos los campos cantidad deben contener valores numéricos mayores a 0" 
            }
        }
        else {
            if (!rex.test(e.cantidad)) 
            {
                ok = false;
                this.errorMsg = "Todos los campos cantidad deben contener valores numéricos mayores a 0" 
            }
        }
      });

      return ok;
    },

    btnEliminarItem(id) {
      this.idItemEliminar = id
      var obj = {
                 txt:'¿Desea eliminar el item del pedido?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarItem
                }
      this.$store.commit('popup/open',obj);
     },

    eliminarItem() {
      this.$store.commit('pedido/eliminarItemPedido',this.idItemEliminar)   
      if (this.$store.state.pedido.carrito.length > 0)
      {
        this.$router.push({ name: 'reload' });
      }
      else
      {
        this.$router.push({ name: 'home' });
      }
    },

    btnEliminar() {
      var obj = {
                 txt:'¿Desea eliminar la devolucion?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarPedido
                }
      this.$store.commit('popup/open',obj);
    },


    eliminarPedido() {
      this.$store.commit('pedido/eliminarPedido')
      this.$router.push({ name: 'home' });
    },



    btnAgregar() {
       this.$router.push({ name: 'realizarDevolucionCat' });
    },


    btnCerrarPopup() {
       this.showPopup = false; 
    },


    btnEnviar() {
       if (this.validar())
       {
         this.showPopup = true; 
       }
       else
       {
         var obj = {
                     txt:this.errorMsg,
                     txtBtnCancel:'',
                     txtBtnOk:'Aceptar',
                     fCancel:null,
                     fOk:null
                   }
         this.$store.commit('popup/open',obj);
       }
     },


     // ----------------------- ENVIAR DEVOLUCION --------------------------

     btnEnviarPopup() {
       if (this.envioValido()) 
       {
         this.$store.commit('loader/start')
         this.$store.state.pedido.carrito.forEach((item => {
 
         var producto = {'ProductoId':item.id,
                          'PromocionId':item.promocionId,
                          'Largo':0,
                          'Ancho':0,
                          'Cantidad':item.cantidad,
                          'PrecioLista':item.precio,
                          'Precio':item.precio,
                         } 

          this.productos.push(producto)  
        }));
 
        var fechaEnt = ''

        this.pedido = {
          'Id': 1,
          'BorradorId': 0,
          'Fecha': this.getFechaActual(),      
          'FechaTarea': "01/01/2000",
          'ClienteId': this.$store.state.user.cliente.Id,
          'ListaPrecioId': this.$store.state.user.cliente.ListaPrecioId,                                 
          "DescuentoComercialPorcentaje": 0,
          "DescuentoComercialImporte": 0,
          'Observaciones': this.observaciones,
          'CodigoHash': Math.floor(Math.random() * 1000000000),
          'Latitud': 0,
          'Longitud': 0,
          'Email': this.email,
          'GpsEncendido': false,
          'Productos': this.productos,
          } 

        this.pedidos.push(this.pedido); 

        axios.post('/WebSalesDevolucion', {"Devoluciones":this.pedidos} ,{
          headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
          }
        )
          .then((response) => {
            this.showPopup = false;
            this.$store.commit('loader/stop')
            console.log(response.data)
            if (response.data.Code == 0)
            {
              if ((response.data.Pedidos != null)&&(response.data.Pedidos[0] != null)&&(response.data.Pedidos[0].Estado != -1))
              {
                if (this.$store.state.pedido.borradorId != 0)
                {
                  this.eliminarBorrador(this.$store.state.pedido.borradorId)
                }
                else
                {
                  this.$store.commit('pedido/eliminarPedido');
                  this.$router.push({name: 'estadoDevolucion'});
                }
              }
              else
              {
                  var obj = {
                              txt:response.data.Pedidos[0].Mensaje,
                              txtBtnCancel:'',
                              txtBtnOk:'Aceptar',
                              fCancel:null,
                              fOk:null
                            }
                  this.$store.commit('popup/open',obj);
              }

            }
            else if (response.data.Code == 99)
            {
              alert(response.data.Message) 
              this.$router.push({name: 'login'});
            }
            else
            {
              alert(response.data.Message);  
            }
          })
          .catch((error) => {
            console.log(error);
          });

         } 
     },


     // ----------------------- GUARDAR PEDIDO --------------------------
     btnGuardar() {
       this.$store.commit('loader/start')
       this.descuentosPedido = [];                         
       this.$store.state.pedido.carrito.forEach((item => {

        var descProd = [];                                  
        this.$store.state.pedido.descuentos.forEach((itemDesc => {

          if ((itemDesc.CategoriaId == item.idCategoria) && (itemDesc.SubcategoriaId == item.idSubcategoria))
          {
            var dp = null
            dp = {'DescuentoId':itemDesc.Id,
                  'DescuentoPorcentaje': itemDesc.PorcentajeDescuento,
                  'DescuentoImporte': (((item.precio*itemDesc.PorcentajeDescuento)/100) * item.cantidad)
                 } 
            descProd.push(dp)
            this.descuentosPedido.push(dp)
          } 
        }))

       var producto = {'ProductoId':item.id,
                       'PromocionId':item.promocionId,
                       'Largo':0,
                       'Ancho':0,
                       'Cantidad':item.cantidad,
                       'Precio':item.precio,
                       'PrecioLista':item.precioLista,
                       'Descuento': item.descuento,
                       'Descuentos':descProd                           
                      }

        this.productos.push(producto)  
       }));

       var f = new Date(Date.parse(this.calendario))
       var mes = parseInt(f.getMonth()) + parseInt(1)
       var fechaEnt = f.getDate()+"/"+mes+"/"+f.getFullYear()

       this.pedido = {
         'Id': 1,
         'BorradorId': this.$store.state.pedido.borradorId,
         'Fecha': this.getFechaActual(),
         'FechaEntrega': '',
         'FechaTarea': "01/01/2000",
         'ClienteId': this.$store.state.user.cliente.Id,
         'ClienteSucursalLinea': 0, 
         'ListaPrecioId': this.$store.state.user.cliente.ListaPrecioId,                                 
         'CondicionVentaId': this.condicionVenta.Id,
         'DepositoId': this.$store.state.user.cliente.DepositoId,
         'Observaciones': this.observaciones,
         'CodigoHash': Math.floor(Math.random() * 1000000000),
         'Latitud': 0,
         'Longitud': 0,
         'Email': this.email,
         'GpsEncendido': false,
         'Productos': this.productos,
         'Descuentos': this.descuentosPedido                 
        } 

       axios.post('/WebSalesBorrador', this.pedido ,{
         headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                 }
         }
       )
        .then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {
            this.$store.commit('pedido/eliminarPedido');
            this.$router.push({name: 'estadoPedido'});
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message) 
            this.$router.push({name: 'login'});
          }
          else
          {
            alert(response.data.Message);  
          }
        })
        .catch((error) => {
          alert("error") 
          console.log(error);
        });
     },


    eliminarBorrador (borradorId) {
      this.$store.commit('loader/start')
      var bdParam = { BorradorId:borradorId,
                      ClienteId:this.$store.state.user.cliente.Id,	
                      EmpleadoId:this.$store.state.user.usuario.EmpleadoId
                    }
  
      axios.put('/WebSalesBorrador',bdParam,{
      headers:{
                  Token:        this.$store.state.user.usuario.Token,
                  ClientSecret: this.$store.state.entorno.clientSecret,
                  EmpresaId:    this.$store.state.entorno.idEmpresa
              }
      }
      ).then((response) => {
        this.$store.commit('loader/stop')
        this.$store.commit('pedido/eliminarPedido');
        if (response.data.Code == 0)
         {
           this.$router.push({name: 'estadoPedido'});
         }
         else if (response.data.Code == 99)
         {
           alert(response.data.Message);
         }
         else
         {
           console.log(">>>>"+response.data.Message);
         }
      },(error) => { console.log(error) 
            alert(error);  })
    
    },


    envioValido() {

      var valido = true  
      var msg = '' 

      if (!valido)  
      {
        var obj = {
                      txt: msg,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
          this.$store.commit('popup/open',obj);
        }

        return valido
     },



     getFechaActual(){
      
       //'Fecha': "dd/mm/yyyy hh:mm",      
        var date    = new Date();
        var dateUTC = new Date();    
        var dia     =  ''
        var mes     =  ''
        var hora    =  ''
        var minuto  =  ''

        dateUTC.setTime(date.getTime() + 10800000) 

        if (dateUTC.getDate()<10)
        {
          dia = '0'+ dateUTC.getDate().toString()
        }
        else
        {
          dia = dateUTC.getDate().toString()
        }

        if ((dateUTC.getMonth() + 1)<10)
        {
          mes = '0'+ (dateUTC.getMonth()+1).toString()
        }
        else
        {
          mes = (dateUTC.getMonth()+1).toString()
        }

        if (dateUTC.getHours()<10)
        {
          hora = '0'+ dateUTC.getHours().toString()
        }
        else
        {
          hora = dateUTC.getHours().toString()
        }

        if (dateUTC.getMinutes()<10)
        {
          minuto = '0'+ dateUTC.getMinutes().toString()
        }
        else
        {
          minuto = dateUTC.getMinutes().toString()
        }

        console.log(dia+'/'+mes+'/'+dateUTC.getFullYear()+' '+hora+':'+minuto)

        return  dia+'/'+mes+'/'+dateUTC.getFullYear()+' '+hora+':'+minuto;
     },

   },

   mounted () {
    if (this.$store.state.user.cliente.Email.length > 1) {
      this.email=this.$store.state.user.cliente.Email
    }
    else if (!this.$store.state.user.usuario.EsEmpleado)  {
      this.email=this.$store.state.user.email
    }   
    this.$store.commit('loader/stop')
    this.onResize()
   },

   created() {
     window.addEventListener('resize', this.onResize)
   },

   beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
   }

 }

</script>

<style scoped>


#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60);
}



#popup-envio-pedido{
  position: absolute;
  top: 50%;
  left: 50%; 
  transform: translate(-50%,-50%);
  width: 400px;
  min-width: 300px;
  border-radius: 15px;
  box-sizing: border-box;
  background: #ffffff;
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
}



#popup-btnClose-container{
  display: flex;            
  flex-direction:row;  
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;  
  justify-content: flex-end; 
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}

.labels-forms{
 margin-left: 30px;
 font-size: 12px;
 color: #5C666F;
 text-align: left;
}


#obs
{
  resize: none;
  width: 325px;
  margin-left: 30px;
  padding: 10px;
  border-radius: 5px;  
  height:90px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  font-family: 'Rubik', sans-serif;
}


.wc{
  background-color: #ffffff;
  width: 340px;
  margin-bottom: 20px;
  margin-left: 30px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}


.wc-mobile{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;    
  align-items: center; 
  background-color: #ffffff;
  width: 90%;
  margin-left: 5%;
  margin-bottom: 20px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}



select :disabled {
  color:#dddddd;
}

#btnContainerPopup{
  height: 80px;
  display: flex;            
  flex-direction: row;  
  justify-content: center;  
  align-items: center;  
}


.botonPopup{
 height: 40px;
 font-size: 10px;
 font-weight: bold;
 margin-left: 10px;
 margin-right: 10px;
 border-radius: 20px;  
 border-style: solid;
 border:none; 
}



#btnclose{
  width: 100px;
  color: #4969B2;
  background: #ffffff; 
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
  height: 30px;
  font-size: 9px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
}

#btnsend{
  width: 100px;
  background: #44C7F4; 
  color: #ffffff;
  outline: none;
  height: 30px;
  font-size: 9px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
}


.boton:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }

.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}


/*----------------------------*/

 #subheader {
  width: 100%;
  height: 35vh;
  background: linear-gradient(#005A9F , #1899D6);
 }

 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }

 #label-container{
  width: 700px;
  height: 10vh;
 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }

  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column; 
   align-items: center; 
  }


#header-pedido{
 width: 700px;
 height: 50px; 
 display: flex;      
 flex-direction: row;  
 justify-content: center; 
 align-items: center; 
}

#header-pedidoL{
 width: 230px;
 height: 100%; 
 display: flex;      
 flex-direction: row;  
 background: #ffffff;
 justify-content: flex-start;
 align-items: center;    
}

#header-pedidoR{
 width: 400px;
 height: 100%; 
 display: flex;      
 flex-direction: row;  
 background: #ffffff;
 justify-content: flex-end;  
 align-items: center;    
}


.nPedido{
 font-size: 18px;
 font-weight: bold;
 color:#5D6770;
}


 input{
 width: 80px; 
 font-size: 18px;
 text-align: center;
 color:#5D6770;
 border-radius: 5px;  
 height:20px;
 border:none; 
 border-style: solid;
 border-width: 1px;
 border: 1px solid #dddddd;
} 

.inputReadonly{
 width: 80px; 
 border:none; 
} 



#label-editar{
 font-size: 12px;
 color:#5D6770;
}


#total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row; 
  justify-content: flex-end; 
  align-items: center; 
}



#list-container{
  width: 660px;
  height: 60vh;
  padding-top: 30px;
  background: #ffffff;
  overflow: auto;
  display: flex;
  flex-direction:column; 
  align-items: center; 
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row; 
  justify-content: flex-end; 
  align-items: center; 
}


.label-total{
 font-size: 16px;
 color:#5D6770;
}

.label-subtotal{
 font-size: 12px;
 color:#5D6770;
}
 

 .labels-forms{
 margin-left: 30px;
 font-size: 12px;
 color: #5C666F;
 text-align: left;
}



#btnEliminar{
  width: 100px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none; 
  /* color: #4969B2; */
  color: #ff0000;
  background: #ffffff; 
  border-radius: 20px;  
  border-width: 1px;
  border: 1px solid #ffffff;
  outline: none;
}



#btnGuardar{
  width: 100px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none; 
  color: #4969B2;
  background: #ffffff; 
  border-radius: 20px;  
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


#btnAgregar{
  width: 120px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


.btnMobile{
  display: flex;
  flex-direction:row; 
  justify-content: center; 
  align-items: center;
  width: 60px;
  height: 25px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  background: #44C7F4; 
  border-color: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


#btnEnviar{
  width: 80px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}


input[type="submit"]:hover
{
  cursor: pointer;
}

#icon:hover{cursor: pointer;}
#btnclose:hover{cursor: pointer;}
#btnsend:hover{cursor: pointer;}


 /* width */
  ::-webkit-scrollbar {
      width: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd; 
      border-radius: 10px;
  }
  
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb; 
      border-radius: 10px;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc; 
  }
  
  
  ::-webkit-scrollbar { 
  display: block; }
 


</style>


// WEBPACK FOOTER //
// src/components/views/devoluciones/devolucion.vue